let routes = [
  /**
   * @description SBP首页
   * @function /sbp
   * @param {Component} Home
   * @param {Name} pathname sbp-home
   */
  {
    path: '/sbp',
    name: 'sbp-home',
    meta: {
      title: 'HSYLC 2022 SBP'
    },
    component: () => import('../../views/sbp/Home')
  },
  /**
   * @description SBP申请页
   * @function /sbp/apply
   * @param {Component} Apply
   * @param {Name} pathname sbp-apply
   */
  {
    path: '/sbp/apply',
    name: 'sbp-apply',
    meta: {
      title: 'HSYLC 2022 SBP'
    },
    component: () => import('../../views/sbp/Apply')
  },
  {
    path: '/sbp/manage',
    name: 'sbp-manage',
    meta: {
      title: 'HSYLC 2022 SBP'
    },
    component: () => import('../../views/sbp/Manage')
  },
  {
    path: '/sbp/course-duration',
    name: 'sbp-course-duration',
    meta: {
      title: 'HSYLC 2022 SBP'
    },
    component: () => import('../../views/sbp/CourseDuration')
  },
  {
    path: '/sbp/week/:week',
    name: 'sbp-manage-week',
    meta: {
      title: 'HSYLC 2022 SBP'
    },
    component: () => import('../../views/sbp/Manage/Week')
  },
  {
    path: '/sbp/pay',
    name: 'sbp-pay',
    meta: {
      title: 'HSYLC 2022 SBP'
    },
    component: () => import('../../views/sbp/Pay')
  },
  {
    path: '/sbp/announcement',
    name: 'sbp-announcement',
    meta: {
      title: 'HSYLC 2022 SBP'
    },
    component: () => import('../../views/sbp/Announcement')
  }
];
routes = routes.map(item => {
  let ret = Object.assign({}, item);
  ret.meta = Object.assign({}, ret.meta);
  return ret;
});
export default routes;
